import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { BackIcon, CheckIcon } from '../Brand/Icon';
import { measureLinkLabel, LINK_LABEL_MAX_CHARS, LINK_LABEL_MAX_WORDS } from '../../utils/externalLinkText';
import './labelDialog.scss';

export default function LinkLabelDialog({ href, label, onSave, onCancel }) {
  const { t } = useTranslation();
  const [value, setValue] = useState(label || '');
  const input = useRef(null);
  const composing = useRef(false);
  const measured = measureLinkLabel(value);
  const invalid = Boolean(measured.text) && !measured.valid;
  useEffect(() => { input.current?.focus({ preventScroll: true }); }, []);
  const save = event => {
    event.preventDefault();
    if (!composing.current && !invalid) onSave(measured.text || null);
  };
  return <Modal open centered title={t('brand:linkEditText')} footer={null} closable={false}
    onCancel={onCancel} focusTriggerAfterClose={false} width={360} className="link-label-dialog">
    <form onSubmit={save}>
      <span className="link-label-dialog__destination" dir="auto">{href}</span>
      <label htmlFor="wiw-link-label">{t('brand:linkText')}</label>
      <input ref={input} id="wiw-link-label" value={value} onChange={event => setValue(event.target.value)}
        onCompositionStart={() => { composing.current = true; }}
        onCompositionEnd={() => { composing.current = false; }}
        onKeyDown={event => {
          // Enter first commits an IME candidate, rather than the link label.
          // Safari can report compositionend before this keydown; 229 still
          // identifies the native composition event in that ordering.
          if (event.key === 'Enter' && (composing.current || event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229)) {
            event.preventDefault();
          }
        }}
        aria-invalid={invalid} aria-describedby="wiw-link-label-limit" placeholder={t('brand:linkAutomaticText')} dir="auto" />
      <p id="wiw-link-label-limit" role={invalid ? 'alert' : undefined}>
        {t('brand:linkTextLimit', { words: LINK_LABEL_MAX_WORDS, count: LINK_LABEL_MAX_CHARS })}
      </p>
      <div className="link-label-dialog__actions">
        <button type="button" onClick={onCancel} aria-label={t('brand:linkTextCancel')}><BackIcon /></button>
        <button type="submit" disabled={invalid} aria-label={t('brand:linkTextSave')}><CheckIcon /></button>
      </div>
    </form>
  </Modal>;
}
